// extracted by mini-css-extract-plugin
export default {"switcher":"PeriodSwitcher_switcher__lFLfJ","button":"PeriodSwitcher_button__GNkfz","active":"PeriodSwitcher_active__JavYY"};